import React, { useEffect, useState } from 'react';
import { FHEDivider } from 'data/components';
import { withStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { tools, Toastr } from 'data/common';
import Config from 'conf';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { Folder } from '@material-ui/icons';
import TableFiles from './TableFiles';
import FormAddFileButton from '../../../../data/components/FormAddFileButton';
import AddFileModal from './AddFileModal';

const propTypes = {
    hasRights: PropTypes.bool.isRequired,
    formDisabled: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    token: PropTypes.string.isRequired,
    deviceId: PropTypes.string.isRequired,
    env: PropTypes.string.isRequired,
};

function FileManager(props) {
    const { id, env, token, deviceId, formDisabled, type, hasRights } = props;
    const [showModal, setShowModal] = useState(false);
    const [files, setFiles] = useState([]);
    const [fileToUpload, setFileToUpload] = useState(null);

    const url = `${Config.url_api}/${env}/files/${type}/${id}`;

    useEffect(() => {
        getFiles();
    }, []);

    const getFiles = async () => {
        const response = await fetch(url, {
            headers: {
                Authorization: token,
                'Device-ID': deviceId,
            },
        });
        const { success, files } = await response.json();
        if (success) {
            setFiles(files);
        }
    };

    const handleFileChange = e => {
        if (e.target.files) {
            setFileToUpload(e.target.files[0]);
        }
    };

    const handleUpload = () => {
        if (!fileToUpload) {
            return;
        }

        // eslint-disable-next-line no-undef
        const formData = new FormData();
        formData.append('file', fileToUpload);

        fetch(url, {
            method: 'POST',
            body: formData,
            headers: {
                Authorization: token,
                'Device-ID': deviceId,
                // 'content-type': file.type,
                // 'content-length': `${file.size}`,
            },
        })
            .then(data => data.json())
            .then(({ success, statusCode }) => {
                if (success) {
                    getFiles();
                    setShowModal(false);
                    return Toastr.success(Translator.translate('generic.files.table.action.upload.success'));
                }
                if (statusCode === 413) {
                    return Toastr.error(
                        Translator.translate('generic.files.table.action.upload.error'),
                        Translator.translate('generic.files.table.action.upload.maxSize'),
                    );
                }
                throw 'Error';
            })
            .catch(err => Toastr.error(Translator.translate('generic.files.table.action.upload.error'), err));
    };

    const handleDownload = async filename => {
        const response = await fetch(`${url}/${filename}`, {
            headers: {
                Authorization: token,
                'Device-ID': deviceId,
            },
        });
        const blob = await response.blob();
        const href = window.URL.createObjectURL(blob);
        const a = Object.assign(document.createElement('a'), {
            href,
            style: 'display:none',
            download: filename,
        });
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(href);
        a.remove();
    };

    const handleDelete = async filename => {
        await fetch(`${url}/${filename}`, {
            method: 'DELETE',
            headers: {
                Authorization: token,
                'Device-ID': deviceId,
            },
        })
            .then(() => {
                getFiles();
                Toastr.success(Translator.translate('generic.files.table.action.delete.success'));
            })
            .catch(err => Toastr.error(Translator.translate('generic.files.table.action.delete.error'), err));
    };

    return (
        <React.Fragment>
            {showModal && (
                <AddFileModal
                    isFileSelected={!!fileToUpload}
                    onFileChange={handleFileChange}
                    onUpload={handleUpload}
                    onClose={() => setShowModal(false)}
                />
            )}
            <div>
                {hasRights && formDisabled && <FormAddFileButton secondPosition={type === 'homes'} sendFunc={() => setShowModal(true)} />}
                <FHEDivider title={Translator.translate(`generic.files.table.title`)} IconComponent={() => <Folder color="primary" />} />

                <TableFiles hasRights={hasRights} files={files} onDelete={handleDelete} onDownload={handleDownload} />
            </div>
        </React.Fragment>
    );
}

function mapStateToProps(state, props) {
    const { history } = props;

    return {
        token: `Bearer ${state.data.user.get('access_token')}`,
        deviceId: state.data.user.get('deviceID'),
        env: history.environment,
    };
}

const styles = {};

FileManager.propTypes = propTypes;

export default withRouter(
    connect(
        mapStateToProps,
        (dispatch, ownProps) => bindActionCreators(tools.mergePropsToAction(ownProps.history.environment, {}), dispatch),
    )(withStyles(styles, { withTheme: true })(FileManager)),
);



// WEBPACK FOOTER //
// ./environments/genericEnv/components/FileManager/index.js